import { intl } from '../../../../../i18n'
import FileExportIcon from '../../../../components/icons/FileExportIcon'
import { BootstrapTooltip } from '../../../../components/tooltips/Tooltip/BootStrapToopTip'
import { colorPalette } from '../../../../style/colorPalette'

interface FileExportProps {
  onClickExport: () => void
  disabled?: boolean
}

const FileExportButton = ({ onClickExport, disabled }: FileExportProps) => {
  return (
    <BootstrapTooltip
      arrow={true}
      title={intl.formatMessage({ id: 'wbs.header.file.export' })}
    >
      <button
        style={{
          backgroundColor: disabled ? colorPalette.monotone[2] : 'transparent',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          cursor: disabled ? 'default' : 'pointer',
          height: '28px',
          width: '28px',
          borderRadius: '50%',
          justifyContent: 'center',
        }}
        onClick={onClickExport}
        disabled={disabled}
      >
        <FileExportIcon height={'15px'} width={'15px'} />
      </button>
    </BootstrapTooltip>
  )
}

export default FileExportButton
